var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chemistry-touch-limit',{attrs:{"initialUrl":_vm.$serviceAPI.getBiologicalTouchLimitInitial,"touchLimitUrl":_vm.$serviceAPI.findBiologicalTouchLimit}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c03e559e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subPage/biologicalTouchLimit.vue
// module id = null
// module chunks = 